import { useHomeContext } from '../../core/context/HomeContext';
import Header from '../../components/Header/Header';
import StoryList from '../../components/StoryList/StoryList';
import ArticleList from '../../components/ArticleList/ArticleList';
import PortraitSlider from '../../components/PortraitSlider/PortraitSlider';
import ExploreSidebar from '../../components/ExploreSidebar/ExploreSidebar';
import useScreenSize from '../../core/hooks/useScreenSize';
import {
  StyledPageContainer,
  StyledPageSidebar,
  StyledPageContent,
  StyledPageMainContent,
  StyledPageMainSidebar,
} from '../../styles/config/pageStyle';

function Home() {
  const [size] = useScreenSize();
  const { trendingCards, moreTrendingCards, articles, reels, trendingHeading, exploreSidebar } =
    useHomeContext();

  return (
    <>
      <Header />

      <StyledPageContainer>
        {size > 991 && (
          <StyledPageSidebar>
            <ExploreSidebar data={exploreSidebar} />
          </StyledPageSidebar>
        )}

        <StyledPageContent>
          <StyledPageMainSidebar>
            <StoryList
              data={trendingCards}
              onLoadMoreClick={moreTrendingCards}
              heading={trendingHeading}
              sidebar
              loadMore
            />
          </StyledPageMainSidebar>

          <StyledPageMainContent>
            <ArticleList articles={[articles[0], articles[1]]} sortComponent />
            <PortraitSlider slides={reels} />
            <ArticleList articles={[articles[2], articles[3]]} />
          </StyledPageMainContent>
        </StyledPageContent>
      </StyledPageContainer>
    </>
  );
}

export default Home;
